
import PageTitle from "../../components/PageTitle.vue";
import { DateTime } from "luxon";

export default {
	components: { PageTitle },
	data() {
		return {
			cargar:false,
			title: "Tipo de Cambio",
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			fecha_hoy:DateTime.now().toISODate(),
			fields: [
				{ key: "acciones", 			label: "Acciones",		  sortable: false },
				{ key: "moneda", 			label: "Moneda", 		  sortable: true },
				{ key: "valorCambio", 		label: "Valor", 	  	  sortable: true },
				{ key: "fecVigenciaInicio", label: "Vigencia Inicio", sortable: true },
				{ key: "estado", 			label: "Estado", 		  sortable: true }],
			items: [],
			filter: null,
			monedas: [],
			form: {
				moneda_id: "",
				moneda_cambio_id: "",
				valorCambio: "",
				fecVigenciaInicio: "",
				fecVigenciaFin: "",
			},
		};
	},
	computed: {
		sortOptions() {
			// Create an options list from our fields
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	methods: {
		async init(){			
			this.listar();
			let {data} = await this.axios.get('select/monedas');
			this.monedas = data;	
		},
		async listar(){
			try {
				let {data} = await this.axios.get('tipoCambios');
				this.items = data;	
				this.totalRows = this.items.length;	
			} catch (error) {
				this.catchAction(error);
			}
		},
		async show(id = 0){
			this.cargar = false;
			try {
				this.reset();
				if(id > 0){
					let {data} = await this.axios.get('tipoCambios/' + id);
					this.form = data;
				}
				// @ts-ignore
				$(".modal").modal({backdrop: 'static', keyboard: false})
			} catch (error) {
				this.catchAction(error);
			}	
		},
		async state(item, state){
			let title = 'Activar?';
			let confirmButtonText = 'Si, Activar.';
			if(state == 0){
				title = 'Desactivar?';
				confirmButtonText = 'Si, Desactivar.';
			}

			this.$swal.fire({
				title: title,
				text: item.nombre,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'Cancelar',
				confirmButtonText: confirmButtonText,
				showLoaderOnConfirm: true,
				preConfirm: (login) => {
					return this.axios.patch('tipoCambios/' + item.id+'/state',{isActive: state})
					.then((result) => {
						return result.data;
					}).catch((err) => {
						this.$swal.showValidationMessage(
							`Request failed: ${err}`
						)
					});
				},
				allowOutsideClick: () => !this.$swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {	
					this.$swal.fire(
						'Estado',
						result.value.msg,
						'success'
					)
					this.listar();
				}
			});
		},
		reset(){
			this.form = {
				moneda_id: "",
				moneda_cambio_id: "",
				valorCambio: "",
				fecVigenciaInicio: "",
				fecVigenciaFin: "",
			}
		},
		async submit(e){
			e.preventDefault();
			let data:any = '';
			let resp:any = '';
			this.cargar = true;
			try {
				resp 	= await this.axios.post('tipoCambios', this.form);
				data	= resp.data;	

				this.listar();
				// @ts-ignore
				$(".modal").modal('hide');
				// @ts-ignore
				new PNotify({
								text: data.msg,
								type: 'success',
								styling: 'bootstrap3'
							});
			} catch (error) {
				this.cargar = false;
				this.catchAction(error);
			}
			this.cargar = false;
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
	mounted() {
		// Set the initial number of items
		this.init();
	},
};
